var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectronicService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 61,
    viewBox: "0 0 62 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.4141 14.9141C60.0625 13.5078 58.3047 13.0391 57.25 14.0938L48.3438 23.1172H38.5V13.2734L47.5234 4.36719C48.5781 3.3125 48.1094 1.55469 46.7031 1.20312C43.8906 0.5 40.8438 0.5 37.7969 1.20312C30.5312 2.96094 24.9062 9.05469 23.8516 16.3203C23.1484 19.3672 23.5 22.4141 24.4375 25.2266L3.57812 46.0859C0.179688 49.3672 0.179688 54.6406 3.57812 57.9219C5.10156 59.6797 7.21094 60.5 9.32031 60.5C11.3125 60.5 13.5391 59.6797 15.2969 58.0391L36.1562 37.1797C38.8516 38.1172 41.8984 38.4688 45.0625 37.8828C52.3281 36.7109 58.4219 31.2031 60.1797 23.9375C61.1172 20.7734 61.1172 17.7266 60.4141 14.9141ZM10.375 53.9375C8.73438 53.9375 7.5625 52.7656 7.5625 51.125C7.5625 49.6016 8.73438 48.3125 10.375 48.3125C11.8984 48.3125 13.1875 49.6016 13.1875 51.125C13.1875 52.7656 11.8984 53.9375 10.375 53.9375Z",
    fill: "#FFB703"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectronicService);
export default __webpack_public_path__ + "static/media/Electronic-Service.822be19240983d459c871aabbc365ea4.svg";
export { ForwardRef as ReactComponent };